import { render, staticRenderFns } from "./group-layout.vue?vue&type=template&id=1810a619&"
import script from "./group-layout.vue?vue&type=script&lang=js&"
export * from "./group-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports